import { connect } from 'react-redux';
import View from './EducationWorkflowView';
import { WORKFLOW_ID } from './EducationWorkflowConstants';
import {
  reloadAdvizrApplication,
  endOfWorkflowsRedirectTo,
  ITERATOR_POST_END,
} from '../AdvWorkflow/AdvWorkflowHelpers';
import {
  getGoalId as getGoalIdSelector,
  childFirstNameOrDefaultSelector,
  childrenListOrDefaultSelector,
} from '../ChildrenInfoWorkflow/ChildrenInfoWorkflowSelector';
import {
  shouldSkipSummaryMultipleGoalsSelector,
  supportDataOrEmptyObjectSelector,
} from '../AdvWorkflow/AdvWorkflowSelector';
import { getGoalPageName } from '../../FinancialPlanOPL/Goals/utils/getGoalPageName';
import { GoalTypeDTO } from '../../FinancialPlanOPL/types/goalsDTO';

const mapStateToProps = (state, ownProps) => {
  const workflowIdAugmentedProps = {
    workflowId: WORKFLOW_ID,
    ...ownProps,
  };
  return {
    ...workflowIdAugmentedProps,
    childFirstName: childFirstNameOrDefaultSelector(state, workflowIdAugmentedProps),
    childrenList: childrenListOrDefaultSelector(state, workflowIdAugmentedProps),
    shouldSkipSummary:
      shouldSkipSummaryMultipleGoalsSelector(state, workflowIdAugmentedProps) &&
      !supportDataOrEmptyObjectSelector(state, workflowIdAugmentedProps).BlockAutoOutput,
  };
};

const mapDispatchToProps = () => ({
  outputFunction: (clientId, childrenList, childFirstName) => () => {
    const { ADV } = window;
    reloadAdvizrApplication(true, false, async () => {
      const currentClient = ADV.util.getCurrentClient(ADV.data);

      const outputRoute = currentClient.ComponentName || getGoalPageName(GoalTypeDTO.Education);

      const goalsList = (
        await ADV.util.request(
          {
            uri: 'Consumer/EducationWorkflowUpdate?workflowIsLastStep=true',
            data: {
              clientId,
              json: JSON.stringify({}),
              'paths[0]': '',
              workflowIsLastStep: true,
              workflowId: 'EducationWorkflow',
              workflowStep: JSON.stringify(ITERATOR_POST_END),
            },
            type: 'POST',
            showSpinner: true,
          },
          true,
        )
      ).payload.viewData.Goals;
      const goalId = getGoalIdSelector(childrenList, childFirstName, goalsList);

      const params = {
        clientId,
        goalId,
      };
      endOfWorkflowsRedirectTo(outputRoute, params);
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
